/* KYRA 17 oct 2026: script anterior del carrito retirado. Lo reemplazan kyra-corner-cart.js (resumen, pagos) y el layout con CSS flex en snippets/kyra-cart-addons.liquid. */
window.KYRA_CART_SCRIPT_VERSION = "stub";
